const actions = ['SET_EMAIL']

const subActions = {}

export default [actions, subActions]
